export const INSURER_LIST = [
  { name: 'COLSEGUROS (AT1301)', code: 'AT1301' },
  { name: 'SEGUROS COLPATRIA (AT1306)', code: 'AT1306' },
  { name: 'ZLS ASEGURADORA DE COLOMBIA SA (AT1309)', code: 'AT1309' },
  { name: 'ROYAL & SUN ALLIANCE SEGUROS (AT1315)', code: 'AT1315' },
  { name: 'MUNDIAL DE SEGUROS (AT1317)', code: 'AT1317' },
  { name: 'COMPAÑÍA SURAMERICANA DE SEGUROS (AT1318)', code: 'AT1318' },
  { name: 'LA PREVISORA S.A. (AT1324)', code: 'AT1324' },
  { name: 'SEGUROS DEL ESTADO (AT1329)', code: 'AT1329' },
  { name: 'LIBERTY SEGUROS (AT1333)', code: 'AT1333' },
  { name: 'ASEGURADORA DE VIDA COLSEGUROS (AT1401)', code: 'AT1401' },
  { name: 'COMPAÑIA AGRICOLA DE SEGUROS (AT1405)', code: 'AT1405' },
  { name: 'SEGUROS DE VIDA COLPATRIA S.A. (AT1404)', code: 'AT1404' },
  { name: 'SEGUROS BOLIVAR S.A. (AT1327)', code: 'AT1327' },
  { name: 'SEGUROS DE VIDA ALFA S.A. (AT1417)', code: 'AT1417' },
  { name: 'LIBERTY SEGUROS DE VIDA S.A. (AT1418)', code: 'AT1418' },
  { name: 'SEGUROS DE VIDA DEL ESTADO S.A (AT1419)', code: 'AT1419' },
  { name: 'LA EQUIDAD SEGUROS DE VIDA (AT1429)', code: 'AT1429' },
  { name: 'BBVA SEGUROS DE VIDA SA (AT1426)', code: 'AT1426' },
  { name: 'COLMENA RIESGOS PROFESIONALES (AT1425)', code: 'AT1425' },
  { name: 'POSITIVA (AT1423)', code: 'AT1423' },
  { name: 'SEGUROS COMERCIALES BOLIVAR (AT1327)', code: 'AT1327' },
  { name: 'ASEGURADORA SOLIDARIA DE COLOMBIA (AT1502)', code: 'AT1502' },
  { name: 'MAPFRE (AT1326)', code: 'AT1326' },
  { name: 'ALLIANZ SEGUROS S.A (AT1301)', code: 'AT1301' },
  { name: 'EQUIDAD SEGUROS (AT1501)', code: 'AT1501' },
  { name: 'OTRA', code: 'OTRA' },
  { name: 'SIN POLIZA(SIN SOAT)', code: 'SIN SOAT' },
];

export const INSURER_LIST_NEW = [
  { name: 'COLSEGUROS (13-01)', code: '13-01' },
  { name: 'SEGUROS COLPATRIA (13-06)', code: '13-06' },
  { name: 'ZLS ASEGURADORA DE COLOMBIA SA (13-09)', code: '13-09' },
  { name: 'ROYAL & SUN ALLIANCE SEGUROS (13-15)', code: '13-15' },
  { name: 'MUNDIAL DE SEGUROS (13-17)', code: '13-17' },
  { name: 'COMPAÑÍA SURAMERICANA DE SEGUROS (13-18)', code: '13-18' },
  { name: 'LA PREVISORA S.A. (13-24)', code: '13-24' },
  { name: 'SEGUROS DEL ESTADO (13-29)', code: '13-29' },
  { name: 'LIBERTY SEGUROS (13-33)', code: '13-33' },
  { name: 'ASEGURADORA DE VIDA COLSEGUROS (14-01)', code: '14-01' },
  { name: 'COMPAÑIA AGRICOLA DE SEGUROS (14-05)', code: '14-05' },
  { name: 'SEGUROS DE VIDA COLPATRIA S.A. (14-04)', code: '14-04' },
  { name: 'SEGUROS BOLIVAR S.A. (45268)', code: '45268' },
  { name: 'SEGUROS DE VIDA ALFA S.A. (14-17)', code: '14-17' },
  { name: 'LIBERTY SEGUROS DE VIDA S.A. (14-18)', code: '14-18' },
  { name: 'SEGUROS DE VIDA DEL ESTADO S.A (14-19)', code: '14-19' },
  { name: 'LA EQUIDAD SEGUROS DE VIDA (14-29)', code: '14-29' },
  { name: 'BBVA SEGUROS DE VIDA SA (14-26)', code: '14-26' },
  { name: 'COLMENA RIESGOS PROFESIONALES (14-25)', code: '14-25' },
  { name: 'POSITIVA (14-23)', code: '14-23' },
  { name: 'SEGUROS COMERCIALES BOLIVAR (45268)', code: '45268' },
  { name: 'ASEGURADORA SOLIDARIA DE COLOMBIA (15-02)', code: '15-02' },
  { name: 'MAPFRE (13-26)', code: '13-26' },
  { name: 'ALLIANZ SEGUROS S.A (13-01)', code: '13-01' },
  { name: 'EQUIDAD SEGUROS (36937)', code: '36937' },
  { name: 'OTRA', code: 'OTRA' },
  { name: 'SIN POLIZA(SIN SOAT)', code: 'SIN SOAT' },
];